function initRiskMapForm() {
    const form = document.getElementById("risk-map-form");
    if (!form || form.dataset.riskMapBound === "true") return;
    form.dataset.riskMapBound = "true";

    const facultySelect = document.getElementById("risk_map_faculty_id");
    const yearInput = document.getElementById("risk_map_year");
    const macroProcessSelect = document.getElementById("risk_map_macro_process_id");
    const linesContainer = document.getElementById("risk-map-lines");
    const addLineButton = document.getElementById("add-risk-map-line");
    const lineTemplate = document.getElementById("risk-map-line-template");
    if (!facultySelect || !yearInput || !macroProcessSelect || !linesContainer || !addLineButton || !lineTemplate) return;

    let mprocessRecords = readSelectRecords(document.querySelector(".risk-map-mprocess"));
    const subProcessCache = {};

    function resetSelect(select, placeholder) {
        select.innerHTML = "";
        const option = document.createElement("option");
        option.value = "";
        option.textContent = placeholder;
        select.appendChild(option);
    }

    function readSelectRecords(select) {
        if (!select) return [];
        return Array.from(select.options)
            .filter(function (option) { return option.value !== ""; })
            .map(function (option) { return { id: option.value, text: option.textContent }; });
    }

    function fillSelect(select, records, placeholder, selectedValue) {
        resetSelect(select, placeholder);
        records.forEach(function (record) {
            const option = document.createElement("option");
            option.value = record.id;
            option.textContent = record.text;
            option.selected = selectedValue && selectedValue.toString() === record.id.toString();
            select.appendChild(option);
        });
    }

    function rows() {
        return Array.from(linesContainer.querySelectorAll(".risk-map-line"));
    }

    function loadSubProcesses(row, selectedValue) {
        const processSelect = row.querySelector(".risk-map-mprocess");
        const subProcessSelect = row.querySelector(".risk-map-sub-process");
        if (!processSelect || !subProcessSelect) return Promise.resolve();

        const mprocessId = processSelect.value;
        if (!mprocessId) {
            resetSelect(subProcessSelect, "Seleccione");
            return Promise.resolve();
        }

        if (subProcessCache[mprocessId]) {
            fillSelect(subProcessSelect, subProcessCache[mprocessId], "Seleccione", selectedValue);
            return Promise.resolve();
        }

        return fetch(`/risk_maps/sub_processes_by_mprocess?mprocess_id=${mprocessId}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Error cargando subprocesos");
                return response.json();
            })
            .then(function (data) {
                subProcessCache[mprocessId] = data;
                fillSelect(subProcessSelect, data, "Seleccione", selectedValue);
            })
            .catch(function (error) { console.error(error); });
    }

    function clearLineHierarchy() {
        mprocessRecords = [];
        rows().forEach(function (row) {
            fillSelect(row.querySelector(".risk-map-mprocess"), [], "Seleccione", null);
            fillSelect(row.querySelector(".risk-map-sub-process"), [], "Seleccione", null);
        });
    }

    function loadMProcesses() {
        const macroProcessId = macroProcessSelect.value;
        const selections = rows().map(function (row) {
            return {
                row: row,
                mprocessId: row.querySelector(".risk-map-mprocess").value,
                subProcessId: row.querySelector(".risk-map-sub-process").value
            };
        });

        if (!macroProcessId) {
            clearLineHierarchy();
            return;
        }

        fetch(`/risk_maps/mprocesses_by_macro_process?macro_process_id=${macroProcessId}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Error cargando procesos");
                return response.json();
            })
            .then(function (data) {
                mprocessRecords = data;
                selections.forEach(function (selection) {
                    const processSelect = selection.row.querySelector(".risk-map-mprocess");
                    fillSelect(processSelect, data, "Seleccione", selection.mprocessId);
                    loadSubProcesses(selection.row, processSelect.value ? selection.subProcessId : null);
                });
            })
            .catch(function (error) { console.error(error); });
    }

    function loadMacroProcesses() {
        const facultyId = facultySelect.value;
        const year = yearInput.value;
        const selectedMacroProcessId = macroProcessSelect.value;

        resetSelect(macroProcessSelect, "Seleccione un macroproceso");
        clearLineHierarchy();
        if (!facultyId || !year) return;

        fetch(`/risk_maps/macro_processes_by_faculty_year?faculty_id=${facultyId}&year=${year}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Error cargando macroprocesos");
                return response.json();
            })
            .then(function (data) {
                fillSelect(macroProcessSelect, data, "Seleccione un macroproceso", selectedMacroProcessId);
                if (macroProcessSelect.value) loadMProcesses();
            })
            .catch(function (error) { console.error(error); });
    }

    function riskEvaluation(probability, impact) {
        const values = {
            "3-5": "Zona de Riesgo Moderado", "2-5": "Zona de Riesgo Tolerable", "1-5": "Zona de Riesgo Aceptable",
            "3-10": "Zona de Riesgo Importante", "2-10": "Zona de Riesgo Moderado", "1-10": "Zona de Riesgo Tolerable",
            "3-20": "Zona de Riesgo Inaceptable", "2-20": "Zona de Riesgo Importante", "1-20": "Zona de Riesgo Tolerable"
        };
        return values[`${probability}-${impact}`] || "";
    }

    function responseMeasures(probability, impact) {
        const values = {
            "3-5": "Prevenir el riesgo.", "2-5": "Aceptar el riesgo. Prevenir el riesgo.", "1-5": "Aceptar el riesgo.",
            "3-10": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "2-10": "Prevenir el riesgo. Proteger la Institución. Compartir.", "1-10": "Proteger la Institución. Compartir.",
            "3-20": "Evitar el riesgo. Prevenir el riesgo. Proteger la Institución. Compartir.",
            "2-20": "Prevenir el riesgo. Proteger la Institución. Compartir.", "1-20": "Proteger la Institución. Compartir."
        };
        return values[`${probability}-${impact}`] || "";
    }

    function calculateLine(row) {
        const probabilitySelect = row.querySelector(".risk-map-probability");
        const impactSelect = row.querySelector(".risk-map-impact");
        const qualificationInput = row.querySelector(".risk-map-qualification");
        const evaluationInput = row.querySelector(".risk-map-evaluation");
        const responseInput = row.querySelector(".risk-map-response-measures");
        const probability = parseInt(probabilitySelect.value, 10);
        const impact = parseInt(impactSelect.value, 10);

        if (!probability || !impact) {
            qualificationInput.value = "";
            evaluationInput.value = "";
            responseInput.value = "";
            return;
        }

        qualificationInput.value = probability * impact;
        evaluationInput.value = riskEvaluation(probability, impact);
        responseInput.value = responseMeasures(probability, impact);
    }

    function bindLine(row) {
        if (row.dataset.bound === "true") return;

        row.querySelector(".risk-map-mprocess").addEventListener("change", function () {
            loadSubProcesses(row, null);
        });
        row.querySelectorAll(".risk-map-probability, .risk-map-impact").forEach(function (select) {
            select.addEventListener("change", function () { calculateLine(row); });
        });
        row.querySelector(".remove-risk-map-line").addEventListener("click", function () {
            const deletedInput = row.querySelector(".risk-map-line-deleted");
            const idInput = row.querySelector('input[name*="[id]"]');
            if (idInput && idInput.value) {
                deletedInput.value = "1";
                row.style.display = "none";
            } else {
                row.remove();
            }
        });

        calculateLine(row);
        row.dataset.bound = "true";
    }

    function addLine() {
        const newId = new Date().getTime();
        linesContainer.insertAdjacentHTML("beforeend", lineTemplate.innerHTML.replace(/NEW_RECORD/g, newId));
        const row = linesContainer.lastElementChild;
        fillSelect(row.querySelector(".risk-map-mprocess"), mprocessRecords, "Seleccione", null);
        fillSelect(row.querySelector(".risk-map-sub-process"), [], "Seleccione", null);
        bindLine(row);
    }

    facultySelect.addEventListener("change", loadMacroProcesses);
    yearInput.addEventListener("change", loadMacroProcesses);
    macroProcessSelect.addEventListener("change", loadMProcesses);
    addLineButton.addEventListener("click", addLine);
    rows().forEach(bindLine);
}

document.addEventListener("DOMContentLoaded", initRiskMapForm);
document.addEventListener("turbolinks:load", initRiskMapForm);
